module.exports = __webpack_public_path__ + "static/img/bonus_4.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_4.png
// module id = l9CE
// module chunks = 0